import axios from 'axios'
import router from '../router'
import { ElMessage } from 'element-plus'

const PRODUCT_API_BASE = '/'

const productAPI = axios.create({
  baseURL: PRODUCT_API_BASE,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器：自动携带token
productAPI.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
}, error => Promise.reject(error))

// 响应拦截器：处理未登录
productAPI.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 || error.response.data?.code === 401)) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      ElMessage.error('登录已过期，请重新登录')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

export const productService = {
  /**
   * 获取商品列表
   * @param {Object} params - 查询参数
   * @param {String} params.category - 分类（可选）
   * @param {Number} params.page - 页码（可选，默认1）
   * @param {Number} params.pageSize - 每页数量（可选，默认20）
   */
  getProductList(params = {}) {
    return productAPI.get('/product/list', { params })
  },

  /**
   * 获取商品详情
   * @param {String} productId - 商品ID
   */
  getProductDetail(productId) {
    return productAPI.get(`/product/${productId}`)
  },

  /**
   * 获取分类列表
   */
  getCategories() {
    return productAPI.get('/product/categories')
  },

  /** 新增商品 */
  createProduct(data) {
    return productAPI.post('/product', data)
  },

  /** 更新商品 */
  updateProduct(id, data) {
    return productAPI.put(`/product/${id}`, data)
  },

  /** 更新上架状态 */
  updateProductStatus(id, status) {
    return productAPI.patch(`/product/${id}/status`, null, { params: { status } })
  },

  /** 删除商品 */
  deleteProduct(id) {
    return productAPI.delete(`/product/${id}`)
  }
}

export default productAPI
